var _mask, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSemiCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 12,
    viewBox: "0 0 20 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_4338_61581",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9998 11.03C19.9999 11.0101 20 10.9902 20 10.9702C20 5.44737 15.5228 0.970215 10 0.970215C4.47715 0.970215 0 5.44737 0 10.9702C0 10.9902 5.84327e-05 11.0101 0.000175136 11.03H19.9998Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9998 11.03V12.53C20.8248 12.53 21.495 11.8638 21.4998 11.0388L19.9998 11.03ZM0.000175136 11.03L-1.4998 11.0388C-1.49497 11.8638 -0.824823 12.53 0.000175136 12.53V11.03ZM18.5 10.9702C18.5 10.9872 18.5 11.0042 18.4998 11.0213L21.4998 11.0388C21.4999 11.016 21.5 10.9931 21.5 10.9702H18.5ZM10 2.47021C14.6944 2.47021 18.5 6.27579 18.5 10.9702H21.5C21.5 4.61894 16.3513 -0.529785 10 -0.529785V2.47021ZM1.5 10.9702C1.5 6.27579 5.30558 2.47021 10 2.47021V-0.529785C3.64873 -0.529785 -1.5 4.61894 -1.5 10.9702H1.5ZM1.50015 11.0212C1.50005 11.0042 1.5 10.9872 1.5 10.9702H-1.5C-1.5 10.9931 -1.49993 11.016 -1.4998 11.0388L1.50015 11.0212ZM0.000175136 12.53H19.9998V9.53003H0.000175136V12.53Z",
    fill: "#2B2B35",
    mask: "url(#path-1-inside-1_4338_61581)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSemiCircle);
export default __webpack_public_path__ + "static/media/semi_circle.9df7eb1e8c7271cd1111ba2cd6561bd9.svg";
export { ForwardRef as ReactComponent };